import { render } from "./ProductTraceDetail.vue?vue&type=template&id=e5445246&scoped=true"
import script from "./ProductTraceDetail.vue?vue&type=script&lang=js"
export * from "./ProductTraceDetail.vue?vue&type=script&lang=js"

import "./ProductTraceDetail.vue?vue&type=style&index=0&id=e5445246&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dxworks\\Downloads\\dpp_adm_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5445246"]])

export default __exports__